export enum ClientViewActionTypes {
  GET_PORTFOLIOS = 'GET_PORTFOLIOS',
  GET_CLIENT_DETAILS = 'GET_CLIENT_DETAILS',
  GET_CLIENT_FAMILY = 'GET_CLIENT_FAMILY',
  CLEAR_CLIENT_STATE = 'CLEAR_CLIENT_STATE',
  GET_PORTFOLIO = 'GET_PORTFOLIO',
  GET_STANDARD_FEES = 'GET_STANDARD_FEES',
  GET_SCENARIO_LIST = 'GET_SCENARIO_LIST',
  CREATE_SCENARIO = 'CREATE_SCENARIO',
  DELETE_SCENARIO = 'DELETE_SCENARIO',
  GET_SCENARIO = 'GET_SCENARIO',
  UPDATE_SCENARIO = 'UPDATE_SCENARIO',
  APPROVAL_SUBMIT = 'APPROVAL_SUBMIT',
  APPROVE_SCENARIO = 'APPROVE_SCENARIO',
  REJECT_SCENARIO = 'REJECT_SCENARIO',
  REQUEST_PRICING_REVIEW = 'REQUEST_PRICING_REVIEW',
  COMPLETE_SCENARIO_REMINDER = 'COMPLETE_SCENARIO_REMINDER',
}
